import { getUtilityClasses } from "../styles";
export const viewLinkMenuContentClasses = getUtilityClasses("ViewLinkMenuContent", [
    "root",
    "linkPreviewText",
]);
